import { Injectable } from '@angular/core';
import { HttpHeaders } from '@angular/common/http';

@Injectable({ providedIn: 'root' })
export class AppGlobals {
  userData: any = localStorage.getItem('currentUser');
  headers = new HttpHeaders({
    'Content-Type': 'application/json',
  });
  default_home_page_limit = 10;

  constructor() {}
}
